const bigTv = window.matchMedia("(min-width: 1900px)").matches || window.matchMedia("(min-width: 1366px) and (max-width: 1899px)").matches;
const bigScreen = window.matchMedia("(min-width: 1900px)").matches;
const normalScreen = window.matchMedia("(min-width: 1366px) and (max-width: 1899px)").matches;
const mobileScreen = window.matchMedia("(min-width: 375px) and (max-width: 420px)").matches;
const iPadScreen = window.matchMedia("(min-width: 760px) and (max-width: 1024px)").matches;
const iPadPro = window.matchMedia("(min-width: 1024px) and (max-width: 1366px)").matches;

export {bigTv, bigScreen, normalScreen, mobileScreen, iPadScreen, iPadPro}